import Icon from '@mui/icons-material/Healing'

import ReferenceValue from '../../components/ReferenceValue'
import organisationsConfig from '../organisations/config'
import vehiclesConfig from '../vehicles/config'

export default {
  name: 'incident-reports',
  recordRepresentation: (
    <>
      <ReferenceValue reference={organisationsConfig.name} />
      {'\u00a0•\u00a0'}
      <ReferenceValue reference={vehiclesConfig.name} />
    </>
  ),
  options: {
    defaultSort: { field: 'created_on', order: 'DESC' },
    defaultFilterValues: {},
    references: ['organisations', 'users', 'vehicles'],
    badge: true,
  },
  icon: Icon,
}
